import React, { useEffect } from 'react';
import "../../assets/Style.css";
import Logo from "../../assets/images/Logo (9).png";
import { Link, NavLink } from "react-router-dom";

const Header = () => {
  useEffect(() => {
    const hamburger = document.querySelector('.hamburger');
    const navLinks = document.querySelector('.nav-links');
    const navItems = document.querySelectorAll('.nav-links a');
    const searchIcon = document.querySelector('.search-icon');
    const searchInput = document.querySelector('.search-container input');

    const toggleNav = () => {
      hamburger?.classList.toggle('active');
      navLinks?.classList.toggle('active');
      document.body.style.overflow = navLinks?.classList.contains('active') ? 'hidden' : '';
    };

    const closeNav = () => {
      hamburger?.classList.remove('active');
      navLinks?.classList.remove('active');
      document.body.style.overflow = '';
    };

    const handleNavItemClick = () => {
      if (window.innerWidth <= 1024) {
        closeNav();
      }
    };

    const toggleSearch = (e) => {
      if (window.innerWidth <= 1024) {
        e.stopPropagation();
        searchInput?.classList.toggle('active');
        if (searchInput?.classList.contains('active')) {
          searchInput.focus();
        }
      }
    };

    const closeSearch = (e) => {
      if (
        window.innerWidth <= 1024 &&
        !e.target.closest('.search-container') &&
        searchInput?.classList.contains('active')
      ) {
        searchInput.classList.remove('active');
      }
    };
// dhrumil
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        closeNav();
      }
    };

    hamburger?.addEventListener('click', toggleNav);
    navItems.forEach(item => item.addEventListener('click', handleNavItemClick));
    searchIcon?.addEventListener('click', toggleSearch);
    document.addEventListener('click', closeSearch);
    window.addEventListener('resize', handleResize);

    // Clean up
    return () => {
      hamburger?.removeEventListener('click', toggleNav);
      navItems.forEach(item => item.removeEventListener('click', handleNavItemClick));
      searchIcon?.removeEventListener('click', toggleSearch);
      document.removeEventListener('click', closeSearch);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <nav className="navbar">
      <Link to="/">
        <img className="logo" src={Logo} alt="Code Buddy's Logo" />
      </Link>
<ul className="nav-links">
        <li><NavLink to="/">Home</NavLink></li>
        <li><NavLink to="/About">About Us</NavLink></li>
        <li><NavLink
          to="/Service"
          className={() =>
            ["/Service", "/creativity", "/logics", "/leads"].some(path =>
              window.location.pathname.startsWith(path)
            )
              ? "active"
              : ""
          }
        >
          Services
        </NavLink></li>

        {/* Independent Portfolio Link */}
        <li><NavLink to="/Portfolio" className={() =>
          ["/Portfolio" ,"/portfolio-details"].some(path =>
            window.location.pathname.startsWith(path)
          )
            ? "active"
            : ""
        }>Portfolio</NavLink></li>

        {/* Independent Products / WordPress Plugin Link */}
        <li><NavLink 
          to="/wordpress-plugin" 
          className={() =>
            window.location.pathname.startsWith("/wordpress-plugin")
              ? "active"
              : ""
          }
        >
          Products
        </NavLink></li>

        {/* Blog Link */}
        <li><NavLink 
          to="/blogs" 
          className={() =>
            ["/blogs", "/blog"].some(path =>
              window.location.pathname.startsWith(path)
            )
              ? "active"
              : ""
          }
        >
          Blog
        </NavLink></li>

        <li><NavLink to="/Contact">Contact Us</NavLink></li>
      </ul>



      <div className="hamburger">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </nav>
  );
};

export default Header;
